/* eslint-disable prettier/prettier */
export default () =>({
  // penitentiaries: null,
  penitentiary: null,
  data: false,


  contador: 1,
  ultimamutacion: 'nada',
  isLoading: false,


  // courtOrderData:null,
  // status: "extracting",
  // segipResponse: null,
  // listPrivatedLibertyPersons:null,
  // countPersonsCenter:null,
  // dataToEdit:null,
  // statusEdit: "not editing",
  // chartData:null,
  // chartStatus:null,
  // chartDataTwoParams:null,
})
